// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "ee405a9a1",
    "hash": "ee405a9a1",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "ee405a9a1",
    "semverString": null,
    "version": "0.0.0",
    "buildDate": "11/5/2026",
    "buildTime": "Thu, 05 Nov 2026 02:42:49 GMT"
};
/* eslint:enable */
